<template>
  <Contact />
</template>

<script>
  import Contact from '../components/Contact.vue'

  export default {
    name: 'Home',

    components: {
      Contact,
    },
  }
</script>
